// extracted by mini-css-extract-plugin
export default {"row":"BottomDescList_row__psEkv","col":"BottomDescList_col__V2T2r","tit":"BottomDescList_tit__IZCwv","desc":"BottomDescList_desc__gpCWZ"};